import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import EventDetailView from './EventDetailView';
import { Creators as inscriptionAction } from '@/domain/useCases/events/setEventInscriptionUseCase';
import { Creators as unsubscriptionAction } from '@/domain/useCases/events/setEventUnsubscribeUseCase';
import { Creators as registerWaitingListAction } from '@/domain/useCases/events/registerWaitingListUseCase';
import routes from '../../../../components/Routes/routingMap';
import { Creators as EventDetailActions } from '../../../../../domain/useCases/events/getEventDetailUseCase';
import NotFoundViewController from '../../../../components/errors/NotFound/NotFoundViewController';
import NotAccesibleViewController from '../../../../components/errors/NotAccesible/NotAccesibleViewController';
import XCheckpointManager from '../../../../../core/managers/xcheckpointManager';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';
import useExternalSettings from '@/presentation/hooks/useExternalSettings';
import { Creators as unregisterWaitingListAction } from '@/domain/useCases/events/unregisterWaitingListUseCase';
import { useRole } from '@/presentation/hooks/useRole';

interface RouteParams {
  eventId: string;
}

const EventDetailViewController = () => {
  const { eventId } = useParams<RouteParams>();
  const { isVisor } = useRole();
  const [openWarningModal, setOpenWarningModal] = useState(false);
  const [restriction, setRestriction] = useState(false);
  const [openVacanciesModal, setOpenVacanciesModal] = useState(false);
  const [openZoomDisabledModal, setOpenZoomDisabledModal] = useState(false);
  const [openZoomNotExistsModal, setOpenZoomNotExistsModal] = useState(false);
  const [openMaximumSubscribedModal, setOpenMaximumSubscribedModal] =
    useState(false);
  const [showModalAlreadySubscribed, setShowModalAlreadySubscribed] =
    useState(false);
  const [registerWLError, setRegisterWLErrorModal] = useState(false);
  const [loadEvents, setLoadEvents] = useState(false);
  const [registerEvent, setRegisterEvent] = useState(false);
  const [isInscription, setIsInscription] = useState<boolean | null>(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const { currentPeriod } = useExternalSettings();
  const { data: selectedEvent, isLoading } = useSelector(
    (state: any) => state.eventDetail
  );
  const stateInscription = useSelector(
    (state: any) => state.setEventInscription
  );

  const stateUnsubscribe = useSelector(
    (state: any) => state.setEventUnsubscribe
  );

  const { campus, career: modality } = useSelector(
    (state: any) => state.profile?.data?.academic
  );

  const stateWaitingList = useSelector(
    (state: any) => state.registerWaitingList
  );

  const stateUnregisterWaitingList = useSelector(
    (state: any) => state.unregisterWaitingList
  );

  const [registerToWaitinglistSuccess, setRegisterToWaitinglistSuccess] =
    React.useState(false);

  const goBackButton = () => {
    GoogleAnalytics.writeLog('back-from-eventDetail', 'backbutton');
    const { data: subcription } = stateInscription;
    const { data: unsubcription } = stateUnsubscribe;
    if (
      (subcription && subcription.message === 'OK') ||
      (unsubcription && unsubcription.message === 'OK') ||
      registerToWaitinglistSuccess
    )
      history.push('/servicios/eventos/Inscritos');
    else history.goBack();
  };

  const register = (idEvent: number) => {
    if (isVisor) {
      setRestriction(true);
      return;
    }
    setIsInscription(true);
    GoogleAnalytics.writeLog(
      'register-to-event',
      'register',
      `Register to: ${idEvent}`
    );
    dispatch(inscriptionAction.setEventInscription(idEvent));
    XCheckpointManager.registerStart('Evento registro');
    setRegisterEvent(true);
  };

  const cancel = (idEvent: number) => {
    if (isVisor) {
      setRestriction(true);
      return;
    }
    setIsInscription(false);
    GoogleAnalytics.writeLog(
      'unregister-to-event',
      'unregister',
      `Unregister to: ${idEvent}`
    );
    dispatch(unsubscriptionAction.setEventUnsubscribe(idEvent));
  };

  const clearEventSubscribe = () => {
    dispatch(inscriptionAction.setEventInscriptionClear());
  };

  const clearEventUnsubscribe = () => {
    dispatch(unsubscriptionAction.setEventUnsubscribeClear());
  };

  const clearRegisterWaitingList = () => {
    setRegisterWLErrorModal(false);
    dispatch(registerWaitingListAction.registerWaitingListClear());
    const router = routes.student.events.home.replace(':category', 'Inscritos');
    history.push(router);
  };

  const clearRegisterWaitingListSilently = () => {
    setRegisterWLErrorModal(false);
    dispatch(registerWaitingListAction.registerWaitingListClear());
  };

  const clearUnregisterWaitingList = () => {
    dispatch(unregisterWaitingListAction.unregisterWaitingListClear());
  };

  const clearRegisterWaitingListWhenError = () => {
    clearRegisterWaitingList();
    const router = routes.student.events.home.replace(':category', 'Inscritos');
    history.push(router);
  };

  const getEventDetail = () => {
    dispatch(
      EventDetailActions.getEventDetail(Number(eventId), campus, modality)
    );
  };

  const updateEventDetail = () => {
    getEventDetail();
  };

  const validarNumero = (id: any) => {
    const regex = /^\d{1,10}$/;
    return regex.test(id);
  };

  const stateEventInscription = () => {
    const { data: subcription } = stateInscription;
    const { data: unSubcription } = stateUnsubscribe;
    setOpenWarningModal(false);
    if (
      (unSubcription && unSubcription?.message === 'OK') ||
      (subcription && subcription?.message === 'OK') ||
      (unSubcription && unSubcription?.message !== 'OK')
    ) {
      updateEventDetail();
    } else if (isInscription && subcription?.message !== 'OK') {
      const router = routes.student.events.home.replace(
        ':category',
        'Inscritos'
      );
      clearEventSubscribe();
      history.push(router);
    }
  };

  useEffect(() => {
    GoogleAnalytics.writeLog(
      'EventDetail',
      'Detail of event',
      `Selected: ${(eventId || '').toString()}`
    );
    return () => {
      clearEventSubscribe();
      clearEventUnsubscribe();
      clearRegisterWaitingListSilently();
      clearUnregisterWaitingList();
    };
  }, []);

  useEffect(() => {
    if (validarNumero(eventId)) {
      XCheckpointManager.registerStart('Evento detalle');
      getEventDetail();
      setLoadEvents(true);
    }
  }, [eventId, campus, modality]);

  useEffect(() => {
    if (!isLoading && selectedEvent && loadEvents) {
      XCheckpointManager.registerEnd('Evento detalle');
      setLoadEvents(false);
    }
  }, [isLoading, selectedEvent]);

  useEffect(() => {
    const { error, data, isLoading: isLoadInscr } = stateInscription;
    if (error) {
      setOpenWarningModal(true);
    }
    if (!error && data) {
      if (data.status === 'Error' && data.message === 'No vacancies') {
        setOpenVacanciesModal(true);
      } else if (
        data.status === 'Error' &&
        data.message === 'ZOOMACCOUNTDISABLE'
      ) {
        setOpenZoomDisabledModal(true);
      } else if (
        data.status === 'Error' &&
        data.message === 'ZOOMACCOUNTNOTEXISTS'
      ) {
        setOpenZoomNotExistsModal(true);
      } else if (
        data.status === 'Error' &&
        data.message === 'MAXIMUMEVENTSSUBSCRIBED'
      ) {
        setOpenMaximumSubscribedModal(true);
      } else if (
        data.status === 'Error' &&
        data.message === 'ALREADYSUBSCRIBEDSAMEWORKSHOP'
      ) {
        setShowModalAlreadySubscribed(true);
      } else if (data.status === 'Error' || data.message !== 'OK') {
        setOpenWarningModal(true);
      } else {
        updateEventDetail();
      }
    }
    if (!isLoadInscr && registerEvent) {
      XCheckpointManager.registerEnd('Evento registro');
      setRegisterEvent(false);
    }
  }, [stateInscription, openWarningModal]);

  useEffect(() => {
    const { error, data } = stateUnsubscribe;
    if (!error && data) {
      if (data.message === 'OK') {
        getEventDetail();
      } else if (data.message !== 'OK' && !openWarningModal) {
        setOpenWarningModal((prev) => prev || true);
      }
    }
  }, [stateUnsubscribe]);

  useEffect(() => {
    if (
      stateWaitingList.data?.status === 'Error' &&
      stateWaitingList.data?.message === 'MAXIMUMEVENTSSUBSCRIBED'
    ) {
      setOpenMaximumSubscribedModal(true);
      return;
    }
    if (
      stateWaitingList.data?.status === 'Error' &&
      stateWaitingList.data?.message === 'ALREADYSUBSCRIBEDSAMEWORKSHOP'
    ) {
      setShowModalAlreadySubscribed(true);
      return;
    }
    if (stateWaitingList.data?.status === 'Error') {
      setRegisterWLErrorModal(true);
      return;
    }
    if (stateWaitingList.isSuccess) {
      getEventDetail();
      setRegisterToWaitinglistSuccess(true);
    }
  }, [stateWaitingList]);

  useEffect(() => {
    if (stateUnregisterWaitingList.isSuccess) {
      history.push('/servicios/eventos/Inscritos');
    }
  }, [stateUnregisterWaitingList]);

  useEffect(() => {
    if (selectedEvent?.statusWaitingList) {
      const statusMap: Record<string, string> = {
        LE: 'lista-espera-join',
        VD: 'lista-espera-join',
        HL: 'listaespera'
      };
      const status = statusMap[selectedEvent.statusWaitingList];
      if (status) {
        const searchParams = new URLSearchParams(history.location.search);
        searchParams.set('status', status);
        history.replace({ search: searchParams.toString() });
      }
    } else {
      const searchParams = new URLSearchParams(history.location.search);
      searchParams.delete('status');
      history.replace({ search: searchParams.toString() });
    }
  }, [selectedEvent, history]);

  if (
    (!isLoading && selectedEvent && !selectedEvent?.isExist) ||
    !validarNumero(eventId)
  ) {
    return <NotFoundViewController />;
  }
  if (!isLoading && selectedEvent && !selectedEvent?.isAccessible) {
    return <NotAccesibleViewController />;
  }

  const registerWaitingListHandler = () => {
    if (isVisor) {
      setRestriction(true);
      return;
    }
    dispatch(
      registerWaitingListAction.registerWaitingList(eventId, currentPeriod)
    );
    GoogleAnalytics.writeLog('portal-services-events-waitingList', 'services');
  };

  const unregisterWaitingListHandler = () => {
    if (isVisor) {
      setRestriction(true);
      return;
    }
    dispatch(unregisterWaitingListAction.unregisterWaitingList(eventId));
    GoogleAnalytics.writeLog(
      'portal-services-events-waitingList-unregister',
      'services'
    );
  };

  return (
    <EventDetailView
      event={selectedEvent}
      isLoading={isLoading}
      goBackButton={goBackButton}
      isProcessing={
        stateInscription.isLoading ||
        stateUnsubscribe.isLoading ||
        stateWaitingList.isLoading ||
        stateUnregisterWaitingList.isLoading
      }
      onRegister={register}
      onCancelSubscription={cancel}
      openWarningModal={openWarningModal}
      openVacanciesModal={openVacanciesModal}
      setOpenVacanciesModal={setOpenVacanciesModal}
      clearEventSubscribe={clearEventSubscribe}
      openZoomDisabled={openZoomDisabledModal}
      setOpenZoomDisabledModal={setOpenZoomDisabledModal}
      openZoomNotExistsModal={openZoomNotExistsModal}
      setOpenZoomNotExistsModal={setOpenZoomNotExistsModal}
      openMaximumSubscribedModal={openMaximumSubscribedModal}
      setOpenMaximumSubscribedModal={setOpenMaximumSubscribedModal}
      stateEventInscription={stateEventInscription}
      onRegisterWaitingList={registerWaitingListHandler}
      isRegisteredWaitingList={
        stateWaitingList.isSuccess && stateWaitingList.data?.status !== 'Error'
      }
      clearRegisterWaitingList={clearRegisterWaitingList}
      showWarningWaitingListModal={
        registerWLError || !!stateUnregisterWaitingList.error
      }
      errorWarningWaitingListMessage={
        stateWaitingList.data?.data ?? stateUnregisterWaitingList.error ?? ''
      }
      restriction={restriction}
      setRestriction={setRestriction}
      clearRegisterWaitingListWhenError={clearRegisterWaitingListWhenError}
      onUnregisterWaitingList={unregisterWaitingListHandler}
      showModalAlreadySubscribed={showModalAlreadySubscribed}
      setShowModalAlreadySubscribed={setShowModalAlreadySubscribed}
    />
  );
};

export default EventDetailViewController;
